<template>
  <middleColumnGrid>
    <template #row1>
      <div class="mtop-15"></div>
    </template>
    <template #row2>
      <patientInfoBox info="medic"/>
    </template>

    <template #row5>
      <div class="mtop-04 pbottom-04 height-scroll pright-20">

        <!-- BIO -->
        <docBioAddOn :filteredRefSheets="refSheetsForBio"/>

        <!-- IMA -->
        <div class="row mtop-25">
          <text-item :txt="t('patient.common.imaging')" styles="font-mBold"/>
          <dropdownBox v-model="dropd">
            <buttonGroup class="mleft-02">
              <svg-item icon="plus" styles="main-m"/>
            </buttonGroup>
            <template #dropd>
              <addImaging @prescribeImaging="prescribeImagingFromPlus"/>
            </template>
          </dropdownBox>
        </div>
        <div v-if="suggestionsFromCclText?.imaging || imagingRegionSuggestions || imagingSuggestionsFromRefSheets">
          <!-- IMA from results regions-->
          <template v-if="imagingRegionSuggestions?.length">
            <refSheetGroup title="Contexte" class="mtop-06">
              <template v-for="(suggestionGroup, index) in imagingRegionSuggestions" :key="index">
                <div class="row">
                  <text-item :txt="suggestionGroup.region" styles="main-h"/>
                  <div class="row mleft-10 gap-04">
                    <template v-for="(findingProcedure, index) in suggestionGroup.findingProcedures" :key="index">
                      <buttonGroup styles="pad-s" @click="prescribeImagingFromGroup(suggestionGroup.region, findingProcedure)">
                        <text-item :txt="findingProcedure" styles="main-l" style="max-width: 12rem;"/>
                      </buttonGroup>
                    </template>
                  </div>
                </div>
              </template>
            </refSheetGroup>
          </template>

          <!-- IMA from refSheet -->
          <template v-for="(resultGroup, resultIndex) in imagingSuggestionsFromRefSheets" :key="resultIndex">
            <refSheetGroup class="mtop-10 w-450" :refSheet="resultGroup.refSheet" :resultReferenceType="resultGroup.resultReferenceType" :showType="true">
              <template v-for="(row, rowIndex) in resultGroup.elements" :key="rowIndex">
                <template v-for="(expr, exprIndex) in row" :key="exprIndex">
                  <list-group styles="pad-s" class="row" @click="prescribeImagingFromExpr(expr)">
                    <!-- <text-item :txt="gen.capitalize(expr.sctSiteTerm)" styles="main-h"/>
                    <text-item txt="-" styles="main-h" class="mleft-04"/>
                    <text-item :txt="expr.sctFindingProcedureTerm" styles="main-h" class="mleft-04" style="max-width: 12rem;"/> -->
                    <text-item :txt="gen.capitalize(expr.matchedText)" styles="main-h"/>

                    <!-- <text-item :txt="expr.sctSiteFindingTerm" styles="main-l" class="mleft-06" style="max-width: 12rem;"/> -->
                    <text-item :txt="expr.unMatchedText" styles="main-l" class="mleft-08" style="max-width: 12rem;"/>
                    <div v-if="expr.isMatched == true" class="mleft-04" @click.stop>
                      <itemModal v-if="currentEntryStore.showAnnotations" :center="true" :uiId="expr.originalText">
                        <svg-item icon="lightning" styles="size-m main-l"/>
                        <template #modal>
                          <showAnnotations :content="expr"/>
                        </template>
                      </itemModal>
                    </div>
                  </list-group>
                </template>
              </template>
            </refSheetGroup>
          </template>

          <!-- IMAGING from refSheet (referenceDocuments) -->
          <template v-for="(refSheet, refSheetIndex) in imagingRefDocsFromRefSheets" :key="refSheetIndex">
            <refSheetGroup class="mtop-10 w-450" :refSheet="refSheet" resultReferenceType="Treatment" :showType="false">
              <template v-for="doc in refSheet.referenceDocuments.imaging" :key="doc.id">
                <list-group styles="pad-s" class="row" @click="prescribeFromReferenceDoc(refSheet, doc)">
                  <text-item :txt="doc.title" styles="main-h"/>
                </list-group>
              </template>
            </refSheetGroup>
          </template>

          <!-- IMA from CclText -->
          <template v-if="suggestionsFromCclText?.imaging.length">
            <refSheetGroup class="mtop-10">
              <template v-for="(expr, index) in suggestionsFromCclText.imaging" :key="index">
                <!-- <list-group styles="pad-s" class="row" @click="prescribeImaging(exprGroup)">
                  <text-item :txt="gen.capitalize(exprGroup.proxyDetails)" styles="main-h"/>
                  <text-item txt="-" styles="main-h" class="mleft-04"/>
                  <text-item :txt="exprGroup.proxyTerm" styles="main-h" class="mleft-04" style="max-width: 12rem;"/>
                </list-group> -->
                <list-group styles="pad-s" class="row" @click="prescribeImagingFromExpr(expr)">
                  <text-item :txt="gen.capitalize(expr.matchedText)" styles="main-h"/>
                  <text-item :txt="expr.unMatchedText" styles="main-l" class="mleft-08" style="max-width: 12rem;"/>
                  <div v-if="expr.isMatched == true" class="mleft-04" @click.stop>
                    <itemModal v-if="currentEntryStore.showAnnotations" :center="true" :uiId="expr.originalText">
                      <svg-item icon="lightning" styles="size-m main-l"/>
                      <template #modal>
                        <showAnnotations :content="expr"/>
                      </template>
                    </itemModal>
                  </div>
                  </list-group>
              </template>
            </refSheetGroup>
          </template>
        </div>

        <!-- CONSEILS -->
        <template v-if="patientFilesFromRefSheets.length">
          <div class="row mtop-25">
            <text-item :txt="t('refSheet.patientFile.list')" styles="font-mBold"/>
          </div>
          <div class="mtop-02">
            <dbGroup>
              <template v-for="(referenceFile, index) in patientFilesFromRefSheets" :key="index">
                <list-group styles="pad-s" class="row" @click="printPatientFile(referenceFile)">
                  <!-- <svg-item icon="printer" styles="size-m main-m" class="mtop-01"/> -->
                  <!-- <text-item :txt="referenceFile.title" styles="main-m" class="mleft-05" style="max-width: 20rem;"/> -->
                  <text-item :txt="referenceFile.title" styles="main-m" style="max-width: 20rem;"/>
                </list-group>
              </template>
            </dbGroup>
          </div>
        </template>

        <!-- MEDICATION -->
        <div class="row mtop-25">
          <text-item :txt="t('patient.common.medication')" styles="font-mBold"/>
        </div>
        <div class="mtop-02">
          <addMedic :showInfoBox="false" :conclusionId="currCclId" :suggestionsByExpr="medicSuggestionsFromRefSheets" :suggestionsFromCclText="suggestionsFromCclText?.medic"/>
        </div>

        <!-- HEALTH PRO -->
        <div class="row mtop-25">
          <text-item :txt="t('common.healthPros')" styles="font-mBold"/>
          <dropdownBox v-model="dropd" openOn='PrescribeHealthProFromPlus'>
            <buttonGroup class="mleft-02">
              <svg-item icon="plus" styles="main-m"/>
            </buttonGroup>
            <template #dropd>
              <addHealthPro @prescribeHealthPro="prescribeHealthProFromPlus"/>
            </template>
          </dropdownBox>
        </div>
        <!-- HEALTH PRO from Result Roots  -->
        <template v-if="healthProSuggestionsFromRegions?.length > 0">
          <refSheetGroup title="Contexte" class="mtop-06 w-450">
            <template v-for="(healthPro, index) in healthProSuggestionsFromRegions" :key="index">
              <list-group styles="pad-s" class="row"  @click="prescribeHealthProFromResultRoot(healthPro)">
                <text-item :txt="healthPro" styles="main-h"/>
              </list-group>
            </template>
          </refSheetGroup>
        </template>
        <!-- HEALTH PRO from refSheet  -->
        <template v-for="(resultGroup, resultIndex) in healthProSuggestionsFromRefSheets" :key="resultIndex">
          <refSheetGroup class="mtop-10 w-450" :refSheet="resultGroup.refSheet" :resultReferenceType="resultGroup.resultReferenceType" :showType="true">
            <template v-for="(row, rowIndex) in resultGroup.elements" :key="rowIndex">
              <template v-for="(expr, exprIndex) in row" :key="exprIndex">
                <list-group styles="pad-s" class="row" @click="prescribeHealthProFromReference(expr)">
                  <text-item :txt="expr.healthProType" styles="main-h"/>
                  <!-- <text-item v-if="expr.sctFindingProcedureTerm" :txt="expr.sctFindingProcedureTerm" styles="main-l" class="mleft-06" style="max-width: 22rem;"/> -->
                  <text-item v-if="expr.unMatchedText" :txt="resolveSingleSuggestion(expr.unMatchedText)" styles="main-l" class="mleft-06" style="max-width: 22rem;"/>
                  <div class="mleft-04" @click.stop>
                    <itemModal v-if="currentEntryStore.showAnnotations" :center="true" :uiId="expr.originalText">
                      <svg-item icon="lightning" styles="size-m main-l"/>
                      <template #modal>
                        <showAnnotations :content="expr"/>
                      </template>
                    </itemModal>
                  </div>
                </list-group>
              </template>
            </template>
          </refSheetGroup>
        </template>

        <!-- HEALTHPRO from refSheet (referenceDocuments) -->
        <template v-for="refSheet in healthProRefDocsFromRefSheets" :key="refSheet.appUserResultReferenceId">
          <refSheetGroup class="mtop-10 w-450" :refSheet="refSheet" resultReferenceType="Treatment" :showType="false">
            <template v-for="doc in refSheet.referenceDocuments.healthPro" :key="doc.id">
              <list-group styles="pad-s" class="row" @click="prescribeFromReferenceDoc(refSheet, doc)">
                <text-item :txt="doc.title" styles="main-h"/>
              </list-group>
            </template>
          </refSheetGroup>
        </template>

        <!-- HEALTH PRO from CclText -->
        <template v-if="suggestionsFromCclText?.healthPro">
          <refSheetGroup class="mtop-10 w-450">
            <template v-for="(exprGroup, index) in suggestionsFromCclText.healthPro" :key="index">
              <list-group styles="pad-s" class="row"  @click="prescribeHealthProFromCclText(exprGroup)">
                <text-item :txt="exprGroup.proxyTerm" styles="main-h"/>
                <text-item :txt="exprGroup.proxyDetails" styles="main-l" class="mleft-06" style="max-width: 22rem;"/>
              </list-group>
            </template>
          </refSheetGroup>
        </template>

        <!-- ADMINISTRATIVE -->
        <div class="row mtop-25 w-450">
          <text-item :txt="t('patient.suggestion.conclusion.adminPerso')" styles="font-mBold"/>
          <div class="mleft-auto"></div>
          <dropdownBox v-model="dropd" openOn="DocAdministrative">
            <es-button-icon icon="gear" folder="menuIcons" styles="img-grey h-16 w-16" class="pad-m"/>
            <template #dropd>
              <editAppUserPreferences title="Favoris" referenceTextType="DocAdministrative" dtoKey="docAdministrative"/>
            </template>
          </dropdownBox>
        </div>
        <searchAdminPerso class="mtop-02"/>

        <!-- ADMINISTRATIVE fix suggestions -->
        <template v-if="patientAge > 4 && patientAge < 65">
          <refSheetGroup title="Contexte" class="mtop-10 w-450">
            <list-group v-if="patientAge > 4 && patientAge < 22" styles="pad-s" @click="prescribeSchoolAbsenceCertificate()">
              <text-item txt="Incapacité école"/>
            </list-group>
            <list-group v-if="patientAge > 16 && patientAge < 65" styles="pad-s" @click="prescribeMedicalLeave()">
              <text-item txt="Incapacité travail"/>
            </list-group>
          </refSheetGroup>
        </template>

        <!-- ADMINISTRATIVE from refSheet-->
        <template v-for="(refSheet, refSheetIndex) in administrativeFromRefSheets" :key="refSheetIndex">
          <refSheetGroup class="mtop-10 w-450" :refSheet="refSheet" resultReferenceType="Treatment" :showType="false">
            <template v-for="(doc, index) in refSheet.administrativeDocumentGroups" :key="index">
              <list-group styles="pad-s" class="row" @click="createAdminDoc(doc)">
                <text-item :txt="doc.mainDescription" styles="main-h"/>
                <text-item :txt="resolveSingleSuggestion(doc.unMatchedText)" styles="main-l" class="mleft-06" style="max-width: 22rem;"/>
              </list-group>
            </template>
          </refSheetGroup>
        </template>

        <!-- ADMINISTRATIVE from refSheet (referenceDocuments) -->
        <template v-for="refSheet in administrativeRefDocsFromRefSheets" :key="refSheet.appUserResultReferenceId">
          <refSheetGroup class="mtop-10 w-450" :refSheet="refSheet" resultReferenceType="Treatment" :showType="false">
            <template v-for="doc in refSheet.referenceDocuments.administrative" :key="doc.id">
              <list-group styles="pad-s" class="row" @click="prescribeFromReferenceDoc(refSheet, doc)">
                <text-item :txt="doc.title" styles="main-h"/>
              </list-group>
            </template>
          </refSheetGroup>
        </template>

        <!-- ADMINISTRATIVE from CclText-->
        <template v-if="suggestionsFromCclText?.documents?.length">
          <refSheetGroup class="mtop-10 w-450">
            <template v-for="(doc, index) in suggestionsFromCclText.documents" :key="index">
              <list-group styles="pad-s" class="row" @click="createAdminDoc(doc)">
                <text-item :txt="doc.mainDescription" styles="main-h"/>
              </list-group>
            </template>
          </refSheetGroup>
        </template>
        <!-- Spacer (important to avoid scrollproblems if <searchAdminPerso/> has a dropdown)-->
        <div style="margin-top: 15rem;"></div>
      </div>
    </template>

  </middleColumnGrid>
</template>


<script setup>
import refSheetGroup from '../../combinedReference/refSheetGroup.vue'
import middleColumnGrid from '../middleColumnGrid.vue'
import addImaging from './addImaging.vue'
import addHealthPro from './addHealthPro.vue'
import addMedic from "@/views/patientMain/editMedic/addMedic.vue"
import docBioAddOn from '../documents/docBioAddOn.vue'
import searchAdminPerso from './searchAdminPerso.vue'
import editAppUserPreferences from '@/views/patientMain/editAppUserPreferences.vue'

import patientInfoBox from '@/views/patientMain/patientInfoBox.vue'
import showAnnotations from '@/views/patientMain/showAnnotations.vue'

import { ref, computed, watch } from 'vue'
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { SUGGESTION_KEYS } from "@/functions/resultSuggestion.js"
import { resolveSingleSuggestion } from '@/functions/documentSuggestions.ts'

import patientapi from "@/api/patientapi"
import appuserapi from "@/api/appuserapi"
import { apiDate } from "@/api/apicommon"
import gen from "@/functions/general.js"
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const currentEntryStore = useCurrentEntryStore();

const dropd = ref("")

//Print
async function printPatientFile(referenceFile) {
  console.log("printPatientFile")
  console.log(referenceFile)
  const fileType = referenceFile.fileType  //"Image" "Pdf"
  if (!['Pdf', 'Image'].includes(fileType)) return;
  const referenceFileId = referenceFile.appUserResultReferenceFileId.toString()
  //API
  const respBlob = await appuserapi.getAppUserReferenceFileStream(referenceFileId)
  if (!respBlob) {return}
  gen.printBlob(respBlob, fileType)
}


//GENERAL
const imagingRegionSuggestions = ref(null)
async function createImagingRegionSuggestions() {
  imagingRegionSuggestions.value = null
  if (!currentEntryStore.currCclResultKeys) return;
  const resultSuggestionKeys = currentEntryStore.currCclResultKeys.resultSuggestionKeys
  if (!resultSuggestionKeys.length) return;
  const validRegions = SUGGESTION_KEYS
    .filter(key => (!["Measures", "CranialNerves1", "NeuroPeriph", "MotorCoordination", "Ent", "Lymph"].includes(key)))
  const ret = resultSuggestionKeys
    .filter(key => validRegions.includes(key))
    .map(key => ({
      "region": t(`patient.suggestion.sign.${key}`, key),
      "findingProcedures": getImagingLabelsForRegion(key),
    }))
  imagingRegionSuggestions.value = ret
}

const IMA_BY_REGION = {
  Head: ['ct', 'mrt'],
  Thorax: ['rxShort', 'ct', 'mrt'],
  default: ['rxShort', 'usShort', 'ct', 'mrt'],
}

function getImagingLabelsForRegion(region) {
  const keys = IMA_BY_REGION[region] ?? IMA_BY_REGION.default;
  return keys.map(key => t(`patient.document.imaging.${key}`));
}

const patientFilesFromRefSheets = ref([])
const imagingSuggestionsFromRefSheets = ref(null)
const healthProSuggestionsFromRefSheets = ref(null)
const administrativeFromRefSheets = ref(null)
const medicSuggestionsFromRefSheets = ref(null)
const refSheetsForBio = ref(null)
const imagingRefDocsFromRefSheets = ref([])
const healthProRefDocsFromRefSheets = ref([])
const administrativeRefDocsFromRefSheets = ref([])

function createSuggestionsFromRefSheets() {
  refSheetsForBio.value = null
  imagingSuggestionsFromRefSheets.value = null
  patientFilesFromRefSheets.value = []
  medicSuggestionsFromRefSheets.value = null
  healthProSuggestionsFromRefSheets.value = null
  administrativeFromRefSheets.value = null
  //result expressions
  const currFilteredExpressions = currentEntryStore.currCclSuggestionsFromResults?.expressions
    // ?.filter(expr => !expr.isFamilyHistory && !expr.isNegated)
    ?.filter(expr => !expr.isNegated)
  if (!currFilteredExpressions) return;
  //refSheets
  const seenIds = new Set()
  const filteredRefSheets = currFilteredExpressions
    .map(expr => expr.refSheet)
    .filter(Boolean)
    .filter(refSheet => {
      const id = refSheet.appUserResultReferenceId
      if (!seenIds.has(id)) {
        seenIds.add(id)
        return true
      }
      return false
    })
  //ReferenceDocuments
  imagingRefDocsFromRefSheets.value = filteredRefSheets.filter(rs => rs.referenceDocuments?.imaging?.length)
  healthProRefDocsFromRefSheets.value = filteredRefSheets.filter(rs => rs.referenceDocuments?.healthPro?.length)
  administrativeRefDocsFromRefSheets.value = filteredRefSheets.filter(rs => rs.referenceDocuments?.administrative?.length)
  //Bio
  refSheetsForBio.value = filteredRefSheets
  //PatientFiles
  patientFilesFromRefSheets.value = filteredRefSheets.flatMap(refSheet => refSheet.patientFiles)
  //Medic
  medicSuggestionsFromRefSheets.value = filteredRefSheets
  //Imaging
  const isImaging = (expr) => {return expr.findingProcedureRoot === "Imaging" && !expr.isSpecialtyOverImaging}
  let refSheetTypedImagingGroups = []
  filteredRefSheets.forEach(refSheet => {
    refSheetTypedImagingGroups.push(createRefSheetWithTypeGroup(refSheet, 'Presentation', ['sctPresentation1', 'sctPresentation2'], isImaging))
    refSheetTypedImagingGroups.push(createRefSheetWithTypeGroup(refSheet, 'Etio', ['sctEtio1', 'sctEtio2'], isImaging))
    refSheetTypedImagingGroups.push(createRefSheetWithTypeGroup(refSheet, 'Complic', ['sctComplic1', 'sctComplic2'], isImaging))
  })
  refSheetTypedImagingGroups = refSheetTypedImagingGroups.filter(Boolean)
  imagingSuggestionsFromRefSheets.value = refSheetTypedImagingGroups
  //HealthPro
  const isHealthPro = (expr) => {return expr.findingProcedureRoot === "General" || expr.healthProType !== "None"}
  let refSheetTypedHealthProGroups = []
  filteredRefSheets.forEach(refSheet => {
    refSheetTypedHealthProGroups.push(createRefSheetWithTypeGroup(refSheet, 'Presentation', ['sctPresentation1', 'sctPresentation2'], isHealthPro))
    refSheetTypedHealthProGroups.push(createRefSheetWithTypeGroup(refSheet, 'Etio', ['sctEtio1', 'sctEtio2'], isHealthPro))
    refSheetTypedHealthProGroups.push(createRefSheetWithTypeGroup(refSheet, 'Complic', ['sctComplic1', 'sctComplic2'], isHealthPro))
    refSheetTypedHealthProGroups.push(createRefSheetWithTypeGroup(refSheet, 'Treatment', ['sctHealthPro'], isHealthPro))

  })
  refSheetTypedHealthProGroups = refSheetTypedHealthProGroups.filter(Boolean)
  healthProSuggestionsFromRefSheets.value = refSheetTypedHealthProGroups
  //Administrative
  administrativeFromRefSheets.value = filteredRefSheets.filter(refSheet => refSheet.administrativeDocumentGroups.length)
}

function createRefSheetWithTypeGroup(refSheet, resultReferenceType, groups, filterFct) {
  const elements = groups
    .map(subGroup => refSheet[subGroup].filter(filterFct))  //Filter refSheet.sctEtio1 for Imaging / healthPro
    .filter(arr => arr.length)                              //Filter out empty arrays ('elements' is an array of arrays)
  return elements.length
    ? { refSheet, resultReferenceType, elements }
    : null
}

const healthProSuggestionsFromRegions = ref(null)
function createHealthProSuggestionsFromRegions() {
  healthProSuggestionsFromRegions.value = null
  const currExpressions = currentEntryStore.currCclSuggestionsFromResults?.expressions
  if (!currExpressions) return;
  const expressionsOfCurrCcl = currExpressions
    .filter(expr => expr.isMatched && !expr.isFamilyHistory && !expr.isNegated)
    .filter(expr => !(expr.siteRootGroup === "Hemato" && ["Substance", "Medic"].includes(expr.aggressorRootGroup)))
    .map(expr => ({
      siteRootGroup: expr.siteRootGroup,
      aggressorRootGroup: expr.aggressorRootGroup
    }))
  const uniqueRootArr = [...new Set(expressionsOfCurrCcl.flatMap(expr => [expr.siteRootGroup, expr.aggressorRootGroup]))]
    .filter(key => (!["None", "Multi", "Pain", "Exogenous", "Physical", "Substance", "Medic"].includes(key)))
    .flatMap(key => key === "Msk" ? ["Ortho", "Rhumato"] : [key])
  healthProSuggestionsFromRegions.value = uniqueRootArr
}

const currCclId = computed(() => {
  return currentEntryStore.currentCcl?.conclusionGroupId.toString()
});

async function prescribeImagingFromGroup(region, imagingProcedure) {
  const documentOriginalText = imagingProcedure + " " + region
  prescribeImagingDoc("ImagingRequest", documentOriginalText)
}

async function prescribeImagingFromExpr(expr) {
  const documentOriginalText = gen.capitalize(expr.matchedText) //gen.capitalize(expr.sctFindingProcedureTerm)  + " " + expr.sctSiteTerm
  const newContent = expr.unMatchedText //expr.originalText
  prescribeImagingDoc("ImagingRequest", documentOriginalText, newContent)
}

async function prescribeFromReferenceDoc(refSheet, referenceDocument) {
  const entryId = currentEntryStore.currentEntryId;
  const cclId = currCclId.value;
  const referenceDocumentId = referenceDocument.id;
  currentEntryStore.setMiddleTab('docTemplate')
  currentEntryStore.emptyCurrentDoc()
  const newPatientDocument = await patientapi.addReferenceTemplateToCcl(entryId, cclId, referenceDocumentId)
  const newReferenceDocument = await appuserapi.getReferenceDocument(referenceDocumentId);
  currentEntryStore.setCurrentDoc(newPatientDocument);
  currentEntryStore.setMiddleRefSheet(refSheet);
  currentEntryStore.setMiddleReferenceDocument(newReferenceDocument)
  currentEntryStore.reloadCurrentEntry();
}

function prescribeImagingFromPlus(internalCode, documentOriginalText) {
  dropd.value = ""
  prescribeImagingDoc(internalCode, documentOriginalText)
}

async function prescribeImagingDoc(internalCode, documentOriginalText, newContent = "") {
  currentEntryStore.setMiddleTab('docTemplate')
  currentEntryStore.emptyCurrentDoc()
  const newDoc = await patientapi.addOfficialTemplateToCcl(currCclId.value, internalCode, documentOriginalText, newContent, "None", currentEntryStore.currentEntryId)
  currentEntryStore.setCurrentDoc(newDoc)
  currentEntryStore.reloadCurrentEntry();
}

async function createAdminDoc(docGroup){
  const documentOriginalText = docGroup.mainDescription;
  const internalCode = docGroup.internalCode;
  const newContent = resolveSingleSuggestion(docGroup.unMatchedText);

  //Reload
  currentEntryStore.setMiddleTab('docTemplate');
  currentEntryStore.emptyCurrentDoc();
  const newDoc = await patientapi.addOfficialTemplateToCcl(currCclId.value, internalCode, documentOriginalText, newContent, "None", currentEntryStore.currentEntryId);
  currentEntryStore.setCurrentDoc(newDoc);
  currentEntryStore.reloadCurrentEntry();

}

async function prescribeMedicalLeave() {
  currentEntryStore.setMiddleTab('docTemplate')
  currentEntryStore.emptyCurrentDoc()
  const newDoc = await patientapi.addOfficialTemplateToCcl(currCclId.value, "MedicalLeaveCertificate", "", "", "None",  currentEntryStore.currentEntryId)
  currentEntryStore.setCurrentDoc(newDoc)
  currentEntryStore.reloadCurrentEntry();  
}

async function prescribeSchoolAbsenceCertificate() {
  currentEntryStore.setMiddleTab('docTemplate')
  currentEntryStore.emptyCurrentDoc()
  const newDoc = await patientapi.addOfficialTemplateToCcl(currCclId.value, "SchoolAbsenceCertificate", "", "", "None",  currentEntryStore.currentEntryId)
  currentEntryStore.setCurrentDoc(newDoc)
  currentEntryStore.reloadCurrentEntry();  
}



//HEALTH PRO
function isMedicalSpeciality(healthProType) {
  return !['Physio', 'Psychotherapist', 'Psychologist', 'Psychomotor', 'Nurse', 'Speech', 'Pedicurist', 'Dietitian', 'Ergo', 'Podiatrist', 'Midwife'].includes(healthProType)
}

async function prescribeHealthProDoc(healthProType, documentOriginalText, newContent) {
  const docGroupType = isMedicalSpeciality(healthProType) ? 'MedicalSpecialtyRequest' : healthProType + 'Request'
  if (healthProType === 'MedicalSpecialty') {healthProType = ''}
  currentEntryStore.setMiddleTab('docTemplate')
  currentEntryStore.emptyCurrentDoc()
  const newDoc = await patientapi.addOfficialTemplateToCcl(currCclId.value, docGroupType, documentOriginalText, newContent, healthProType,  currentEntryStore.currentEntryId)
  currentEntryStore.setCurrentDoc(newDoc)
  currentEntryStore.reloadCurrentEntry();
}

function prescribeHealthProFromResultRoot(healthProType) {
  const documentOriginalText = healthProType
  const newContent = ""
  prescribeHealthProDoc(healthProType, documentOriginalText, newContent)
}

function prescribeHealthProFromPlus(healthProType, documentOriginalText) {
  dropd.value = ""
  const newContent = ""
  prescribeHealthProDoc(healthProType, documentOriginalText, newContent)
}

function prescribeHealthProFromReference(healthProExpr) {
  const { healthProType, unMatchedText } = healthProExpr;
  const documentOriginalText = healthProType;
  const newContent = resolveSingleSuggestion(unMatchedText);
  prescribeHealthProDoc(healthProType, documentOriginalText, newContent);
}

function prescribeHealthProFromCclText(exprGroup) {
  if (exprGroup === null) {console.log("No exprGroup"); return;}
  if (exprGroup.proxyKey === "") {console.log("No healthProType"); return;}

  const healthProType = exprGroup.proxyKey
  const documentOriginalText = exprGroup.proxyTerm

  let newContent = ""

  prescribeHealthProDoc(healthProType, documentOriginalText, newContent)
}

const suggestionsFromCclText = ref(null)
function getSuggestionsFromCclText() {
  suggestionsFromCclText.value = currentEntryStore.currCclSuggestionsFromCclText
}

const patientAge = computed(() => {
  const entryDate = apiDate(currentEntryStore.currentEntryDate)
  const birthDate = apiDate(currentEntryStore.currentPatient.birthDate)
  const timeDifference = entryDate - birthDate
  const years = timeDifference / (365 * 24 * 60 * 60 * 1000)
  return years
})


watch(
  () => currentEntryStore.currCclSuggestionsFromCclText,
  () => {
    getSuggestionsFromCclText()
  },
  { immediate: true }
)

watch(
  () => currentEntryStore.currCclSuggestionsFromResults,
  () => {
    createImagingRegionSuggestions()
    createHealthProSuggestionsFromRegions()
    createSuggestionsFromRefSheets()
  },
  { immediate: true }
)


</script>


<style scoped>
.height-scroll {
  height: calc(100vh - 366px);
  overflow-y: auto;
}
</style>